<template>
<!-- I will see how you implement this page and after will spread the gray background -->
    <div>
        <div v-if="errorMessage.length">
            {{errorMessage}}
        </div>

        <div v-if="loaded">
            <div class="tracker-section">
                <h2 class="tracker-name heading2">
                    {{ info.name }} - {{info.enterprise_name}}
                </h2>

                <!--<a href="#" class="info-plate">Info & Manage</a>-->

                <div class="info-plate info-plate--updated">

                    <div class="info-plate__link" v-b-toggle.collapse-1 variant="primary">
                        Info
                    </div>

                    <b-collapse id="collapse-1" class="info-plate__content" :visible="startupsCount == 0">

                        <b-card no-body>
                            <b-tabs justified>
                                <b-tab title="Overview" active>
                                  <h5 class="heading5 heading5--secondary d-flex justify-content-between align-items-center mb-3">
                                    <span>{{info.name}}</span>
                                  </h5>

                                    <p><strong>Created:</strong> {{info.created}}</p>

                                    <template v-if="info.type == 'public' || info.status != 'draft'">
                                        <p><strong>Status:</strong> {{constants.trackerStatus[info.status]}}</p>
                                    </template>

                                    
                                    <template v-if="info.description">
                                      <p><strong>Description</strong></p>
                                      <div v-html="info.description" class="info-plate__description"></div>
                                    </template>

                                    <template v-if="info.start_date">
                                      <p><strong>Start Date:</strong> {{info.start_date}}</p>
                                    </template>

                                    <template v-if="info.end_date">
                                      <p><strong>End Date:</strong> {{info.end_date}}</p>
                                    </template>

                                    <div class="text-center">
                                        <button class="btn btn-red" @click="leave">Leave Project</button>
                                    </div>

                                </b-tab>

                            </b-tabs>
                        </b-card>

                    </b-collapse>
                </div>
            </div>

            <div class="tracker-list__actions">
                <div>
                    <template v-if="startupsCount">
                        Show
                        <select v-if="startupsCount > 20" v-model="pageLength" class="select-transparent">
                            <option value="20">20</option>
                            <option value="50" v-if="startupsCount > 20">50</option>
                            <option value="100" v-if="startupsCount > 50">100</option>
                        </select>
                        <template v-else>{{startupsCount}}</template>
                        entries of {{startupsCount}}
                    </template>
                </div>

                <ul class="actions-list">
                    <template v-if="selectedRows.length">
                        <li class="actions-list__remove"><a @click="removeStartups"><font-awesome-icon :icon="['fa', 'trash']" /> Remove From Project</a></li>
                    </template>
                    <template v-else>
                        <li class="actions-list__add"><a @click="$refs.addStartups.open()">Add Startups</a></li>
                    </template>
                </ul>

            </div>
            
            <div class="scroll-anchor"></div>
        
            <main class="main main--dark">

                <div v-if="listLoaded" class="content-tracker-list">
                    <Grid
                        v-if="startups.length"
                          :columns="columns"
                          :has-checkbox-column="true"
                          :data="startups"
                          :addCellData="addCellData"
                          :page-length="parseInt(pageLength)"
                          :total-rows-count="totalRowsCount"
                          :sort="sort"
                          :currentPage="currentPage"
                          v-on:changePage="changePage"
                          v-on:changeSort="changeSort"
                          v-on:selectedRowsChanged="changeSelectedRows"
                          v-on:selectAllResults="selectAllResults"
                    >
                    </Grid>
                    <div v-else class="start-startup">
                        <p>Add your startups to this project to share them with {{info.enterprise_name}}</p>
                        <button class="btn btn-primary btn-lg" @click="$refs.addStartups.open()">+ Add Startups</button>
                    </div>

                </div>
            </main>
        </div>

        <AddStartups
            ref="addStartups"
            :trackerId="id"
            v-on:startupsAdded="startupsAdded"
        >
        </AddStartups>

    </div>
</template>

<script>

import Grid from "@/components/Grid"
import trackers from "@/services/ecosystem/trackers.service"
import grid from '@/mixins/grid'
import AddStartups from "@/components/trackers/AddEcosystemStartups"
import Vue from "vue";

  export default {
      components: {
          Grid,
          AddStartups,
      },

      mixins: [grid],

      data() {
          return {
              id: parseInt(this.$route.params.id),
              loaded: false,
              listLoaded: false,
              errorMessage: "",
              startups: [],
              startupsCount: null,

              info: {
                  name: '',
                  description: '',
                  type: '',
                  created: "",
              },

              addCellData: {
                  companyType: "startups",
              },

              columns: [
                  {
                      label: 'Name',
                      name: 'name',
                      component: 'SearchCompanyNameColumn',
                  },
                  {
                      label: 'Stage',
                      name: 'stage',
                  },
                  {
                      label: 'Location',
                      name: 'location',
                      component: 'SearchCompanyLocationColumn',
                  },
                  {
                      label: 'Total Raised',
                      name: 'total_raised',
                  },
                  {
                      label: 'Employees',
                      name: 'employees',
                  },
                  {
                      label: 'Added',
                      name: 'created_at',
                  },
              ],

              pageLength: 20,
          }
      },

      mounted() {
          this.getInfo()
          this.getList()

          this.$store.watch(state => {
              if (state.needUpdateStartups) {
                  this.getList()
              }
          })
      },

      methods: {
          getList() {
              let sort = this.sort
              let currentPage = this.currentPage
              let pageLength = this.pageLength
              let columns = this.arrayHelper.arrayColumn(this.columns, 'name')

              trackers.getStartupsList(this.id, {
                  sort,
                  columns,
                  currentPage,
                  pageLength
              }).then(response => {
                  this.startups = response.data.data
                  this.totalRowsCount = parseInt(response.data.total_count)
                  this.currentPage = response.data.current_page
                  this.listLoaded = true
                  this.startupsCount = this.totalRowsCount
              })
          },

          getInfo() {
              trackers.getInfo(this.id).then(response => {
                  this.info = response.data
                  document.title = this.info.name + ' | SwitchPitch'

                  this.loaded = true
              }).catch(error => {
                  this.errorMessage = error.response.data.message
              })
          },

          openManageColumns() {
              this.$refs.manageColumns.open()
          },

          startupsAdded() {
              if (this.listLoaded) {
                  this.getList()
              }
          },

          editReview(startupId) {
              this.$refs.editReview.open(this.id, startupId)
          },

          showReviews(startupId) {
              this.$refs.reviews.open(this.id, startupId)
          },

          changeSelectedRows(ids) {
              this.selectedRows = ids
          },

          selectAllResults(result) {
              this.selectedAllResults = result
          },

          removeStartups() {
              if (this.selectedAllResults) {
                  if (confirm(this.totalRowsCount + " startup(s) will be removed from project. Do you want to proceed?")) {
                      trackers.removeAllStartups(this.id).then(() => {
                          this.getList()
                      })
                  }
              }
              else {
                  if (confirm(this.selectedRows.length + " startup(s) will be removed from project. Do you want to proceed?")) {
                      trackers.removeStartups(this.selectedRows, [this.id]).then(() => {
                          this.getList()
                      })
                  }
              }
          },

          leave() {
              if (confirm("Leave Project? Your company will no longer be able to add startups")) {
                  trackers.leave(this.id).then(() => {
                      Vue.notify({
                          group: 'app',
                          type: 'success',
                          duration: 5000,
                          text: "Left project " + this.info.name
                      })
                  })

                  this.$router.push('/')
              }
          }
      }
  }
</script>